/* Sublene premium motion engine
   Scroll reveals · 3D tilt (cards + [data-sbl-tilt]) · hero parallax · count-up stats.
   Dependency-free, passive listeners, rAF-throttled, honors prefers-reduced-motion. */
(function () {
  'use strict';
  document.documentElement.classList.add('sbl-js');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;
  var finePointer = window.matchMedia('(hover:hover) and (pointer:fine)').matches;

  /* ---------- scroll reveal ---------- */
  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    var sections = document.querySelectorAll('#MainContent .shopify-section, #MainContent > section, .t4s-section');
    if (!sections.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('sbl-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    sections.forEach(function (s) {
      var r = s.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.8) return;
      s.classList.add('sbl-reveal');
      io.observe(s);
    });
  }

  /* ---------- 3D tilt: product cards + any [data-sbl-tilt] ---------- */
  function tiltTargetFrom(el) {
    var t = el.closest && (el.closest('[data-sbl-tilt]') || el.closest('.t4s-product'));
    if (!t) return null;
    var inner = t.matches('[data-sbl-tilt]')
      ? (t.querySelector('.sbl-tile__inner') || t.firstElementChild)
      : t.querySelector('.t4s-product-inner');
    return inner ? { root: t, inner: inner } : null;
  }
  function initTilt() {
    if (!finePointer) return;
    var MAX = 5;
    document.addEventListener('pointermove', function (ev) {
      var t = tiltTargetFrom(ev.target);
      if (!t) return;
      t.root.classList.add('sbl-tilt');
      var r = t.root.getBoundingClientRect();
      var px = (ev.clientX - r.left) / r.width - 0.5;
      var py = (ev.clientY - r.top) / r.height - 0.5;
      t.inner.style.setProperty('--sbl-ry', (px * MAX).toFixed(2) + 'deg');
      t.inner.style.setProperty('--sbl-rx', (-py * MAX).toFixed(2) + 'deg');
      t.inner.style.setProperty('--sbl-ty', '-6px');
    }, { passive: true });
    document.addEventListener('pointerout', function (ev) {
      var t = tiltTargetFrom(ev.target);
      if (!t || (ev.relatedTarget && t.root.contains(ev.relatedTarget))) return;
      t.inner.style.setProperty('--sbl-rx', '0deg');
      t.inner.style.setProperty('--sbl-ry', '0deg');
      t.inner.style.setProperty('--sbl-ty', '0px');
      setTimeout(function () { t.root.classList.remove('sbl-tilt'); }, 450);
    }, { passive: true });
  }

  /* ---------- hero parallax ---------- */
  function initParallax() {
    if (!finePointer) return;
    var media = document.querySelector('[data-sbl-parallax]');
    if (!media) return;
    var hero = media.closest('[data-sbl-hero]') || media.parentElement;
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        var h = hero.offsetHeight || 1;
        if (y <= h) media.style.transform = 'translateY(' + (y * 0.28).toFixed(1) + 'px)';
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- count-up stats ---------- */
  function initCounters() {
    var els = document.querySelectorAll('[data-sbl-count]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target;
        var target = parseFloat(String(el.getAttribute('data-sbl-count')).replace(/[^\d.]/g, '')) || 0;
        var dec = parseInt(el.getAttribute('data-sbl-decimals') || '0', 10);
        var dur = 1400, t0 = null;
        function step(ts) {
          if (!t0) t0 = ts;
          var p = Math.min((ts - t0) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = (target * eased).toFixed(dec);
          if (p < 1) requestAnimationFrame(step);
          else el.textContent = target.toFixed(dec);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }


  /* ---------- custom mega-nav panels ---------- */
  function initMegaNav() {
    if (!finePointer || window.innerWidth < 1025) return;
    var tpls = document.querySelectorAll('template[data-sbl-meganav]');
    if (!tpls.length) return;
    var header = document.querySelector('.t4s-section-header') || document.querySelector('header');
    if (!header) return;
    var openPanel = null, closeTimer = null;

    function close(panel) { if (panel) panel.classList.remove('is-open'); if (openPanel === panel) openPanel = null; }
    function open(panel) {
      if (openPanel && openPanel !== panel) close(openPanel);
      clearTimeout(closeTimer);
      panel.classList.add('is-open');
      openPanel = panel;
    }
    function scheduleClose(panel) {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () { close(panel); }, 140);
    }

    tpls.forEach(function (tpl) {
      var url = tpl.getAttribute('data-url');
      var trigger = null;
      document.querySelectorAll('.t4s-type__drop').forEach(function (item) {
        if (trigger) return;
        var a = item.querySelector(':scope > a[href]');
        if (a && a.getAttribute('href') === url) trigger = item;
      });
      if (!trigger) return;

      trigger.classList.add('sbl-has-meganav');
      var panel = document.createElement('div');
      panel.className = 'sbl-mn';
      panel.appendChild(tpl.content.cloneNode(true));
      header.appendChild(panel);

      /* preview crossfade + tag */
      var imgs = panel.querySelectorAll('.sbl-mn__pimg');
      var tag = panel.querySelector('[data-sbl-mn-tag]');
      var plink = panel.querySelector('[data-sbl-mn-plink]');
      var links = panel.querySelectorAll('[data-sbl-mn-link]');
      function activate(i, title, href) {
        imgs.forEach(function (im) { im.classList.toggle('is-on', im.getAttribute('data-pidx') === String(i)); });
        if (tag && title) tag.textContent = title;
        if (plink && href) plink.setAttribute('href', href);
      }
      if (links.length) {
        var first = links[0];
        activate(0, first.querySelector('.sbl-mn__ttl') && first.querySelector('.sbl-mn__ttl').textContent, first.getAttribute('href'));
        links.forEach(function (l) {
          l.addEventListener('pointerenter', function () {
            activate(l.getAttribute('data-idx'), l.querySelector('.sbl-mn__ttl') && l.querySelector('.sbl-mn__ttl').textContent, l.getAttribute('href'));
          }, { passive: true });
        });
      }

      /* hover behavior with grace period */
      trigger.addEventListener('pointerenter', function () { open(panel); }, { passive: true });
      trigger.addEventListener('pointerleave', function () { scheduleClose(panel); }, { passive: true });
      panel.addEventListener('pointerenter', function () { clearTimeout(closeTimer); }, { passive: true });
      panel.addEventListener('pointerleave', function () { scheduleClose(panel); }, { passive: true });
      /* keyboard support */
      trigger.addEventListener('focusin', function () { open(panel); });
      panel.addEventListener('focusout', function (e) { if (!panel.contains(e.relatedTarget)) close(panel); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openPanel) close(openPanel); });
  }

  function boot() { initReveal(); initTilt(); initParallax(); initCounters(); initMegaNav(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
